import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IPhone, Phone} from '../../shared/model/phone.model';
import {createRequestOption} from '../../shared/util/request-util';
import {SERVER_API_URL} from '../../app.constants';
import {map} from "rxjs/internal/operators";

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

//import * as XLSX from 'xlsx';


//import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
type EntityResponseType = HttpResponse<IPhone>;
type EntityArrayResponseType = HttpResponse<IPhone[]>;

@Injectable({providedIn: 'root'})
export class PhoneService {
  public resourceUrl = SERVER_API_URL + 'api/phones';
  public resourceUrlNumberValidation = SERVER_API_URL + 'api/phones-number-validation';
  public resourceUrlAudeinceValidation = SERVER_API_URL + 'api/phones-audience-validation';

  constructor(protected http: HttpClient) {
  }

  create(phone: IPhone): Observable<EntityResponseType> {
    return this.http.post<IPhone>(this.resourceUrl, phone, {observe: 'response'});
  }

  createValidationNumber(phone: IPhone): Observable<EntityResponseType> {
    return this.http.post<IPhone>(this.resourceUrlNumberValidation, phone, {observe: 'response'});
  }

  createValidationAudience(phone: IPhone): Observable<EntityResponseType> {
    return this.http.post<IPhone>(this.resourceUrlAudeinceValidation, phone, {observe: 'response'});
  }

  update(phone: IPhone): Observable<EntityResponseType> {
    return this.http.put<IPhone>(this.resourceUrl, phone, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<Phone>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IPhone[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
  findWithSupplierId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IPhone[]>(`${this.resourceUrl + '-supplier'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findWithEmployeeId(id: number): Observable<EntityArrayResponseType> {
    return this.http
      .get<IPhone[]>(`${this.resourceUrl + '-employee'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((contract: IPhone) => {
        // contract.expiratioDate = contract.expiratioDate != null ? moment(contract.expiratioDate) : null;
      });
    }
    return res;
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IPhone[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IPhone[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  }

  searchAdvanced(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IPhone[]>(this.resourceUrl + '-search-advanced', {params: options, observe: 'response'});
  }

  searchByGroup(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IPhone[]>(this.resourceUrl + '-search-group', {params: options, observe: 'response'});
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // alert(' json == ' + json.length);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


}
